import React, { createContext, useState, useContext, useEffect } from "react";
import schoolApi from "../../api/schoolApi";
import jwt_decode from "jwt-decode";

const PermissionContext = createContext();

export const usePermissions = () => {
  return useContext(PermissionContext);
};

export const PermissionProvider = ({ children }) => {
  const [rolePermissions, setRolePermissions] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchPermissions = async () => {
    try {
      const moduleIdsStringresult = await schoolApi.getRolePermissionByIds();

      if (moduleIdsStringresult.success) {

        setRolePermissions(moduleIdsStringresult.result);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const getUserInfoFromToken = () => {
    const token = sessionStorage.getItem("token");
    if (token) {
      try {
        const decodedToken = jwt_decode(token);
        return decodedToken;
      } catch (error) {
        return null;
      }
    } else {
      return null;
    }
  };

  useEffect(() => {
    const handleLocationChange = () => {
      if (window.location.pathname.endsWith("/login")) {
        return;
      }
      fetchPermissions();
    };

    if (
      !window.location.pathname.endsWith("/login") &&
      !/\/razorpay-checkout\/[^/]+$/.test(window.location.pathname)
    ) {
      fetchPermissions();
    }

    window.addEventListener("popstate", handleLocationChange);
    return () => {
      window.removeEventListener("popstate", handleLocationChange);
    };
  }, []);

  const userInfo = getUserInfoFromToken();

  return (
    <PermissionContext.Provider value={{ rolePermissions, loading, userInfo }}>
      {children}
    </PermissionContext.Provider>
  );
};
